import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function EditMasterdataModal({
  isOpen,
  onClose,
  selectedKey,
  modalData,
  handleEditSubmit,
  isDisable,
  processCategories,
  processLocations,
  areas,
}) {
  console.log('key', selectedKey);

  const [inputValue, setInputValue] = useState(modalData?.name || '');
  const [regionValue, setRegionValue] = useState(modalData?.area_id || ''); // New state for region
  const [codeValue, setCodeValue] = useState(modalData?.code || ''); // New state for region
  const [processCategoryId, setProcessCategoryId] = useState(
    modalData?.process_category_id || ''
  );
  const [processLocationId, setProcessLocationId] = useState(
    modalData?.process_location_id || ''
  );
  const { t } = useTranslation('MasterData');
  useEffect(() => {
    const modalElement = document.getElementById('edit-master-data');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }

    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);

  useEffect(() => {
    setInputValue(modalData?.name || '');
    setRegionValue(modalData?.area_id || '');
    setCodeValue(modalData?.code || '');
    setProcessCategoryId(modalData?.process_category_id || '');
    setProcessLocationId(modalData?.process_location_id || '');
  }, [modalData]);

  const handleSave = async () => {
    const updatedData = { name: inputValue };
    if (selectedKey === 'MASTER_DATA_DISTRICT') {
      // updatedData.region = regionValue;
      updatedData.area_id = regionValue;
    }
    if (
      selectedKey === 'MASTER_DATA_ORIGIN' ||
      selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY'
    ) {
      updatedData.code = codeValue;
    }
    if (selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY') {
      updatedData.process_category_id = processCategoryId;
      updatedData.process_location_id = processLocationId;
    }
    handleEditSubmit(updatedData, modalData.id);
  };

  // Mapping for Modal Title and Input Label
  const keyMappings = {
    MASTER_DATA_CUSTOMER_CATEGORY: t('CUSTOMERCATEGORY'),
    MASTER_DATA_AREA: t('AREA'),
    MASTER_DATA_DISTRICT: t('DISTRICT'),
    MASTER_DATA_DELIVERY_STATUS: t('DELIVERYSTATUS'),
    MASTER_DATA_LOGISTIC_LINE: t('LOGISTICLINE'),
    MASTER_DATA_ORDER_STATUS: t('ORDERSTATUS'),
    MASTER_DATA_ORIGIN: t('ORIGIN'),
    MASTER_DATA_PAYMENT_METHOD: t('PAYMENTMETHOD'),
    MASTER_DATA_PAYMENT_STATUS: t('PAYMENTSTATUS'),
    MASTER_DATA_PROCESS_LOCATION: t('PROCESSLOCATION'),
    MASTER_DATA_PROCESS_CATEGORY: t('PROCESSCATEGORY'),
    MASTER_DATA_PRODUCT_CATEGORY: t('PRODUCTCATEGORY'),
    MASTER_DATA_SPECIFICATION_UNIT: t('SPECIFICATIONUNIT'),
    // "MASTER_DATA_SPECIFICATION_VALUE": "Specification Value"
    MASTER_DATA_PRODUCT_UNIT: t('PRODUCTUNIT'),
  };

  const modalTitle = `${t('EDIT')} ${keyMappings[selectedKey] || ''}`;
  const inputLabel = `${keyMappings[selectedKey] || t('NAME')}`;

  return (
    <div
      className="modal fade"
      id="edit-master-data"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {modalTitle}
            </h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => onClose('edit')}
            ></button>
          </div>
          <div className="modal-body">
            <div className="did-floating-label-content">
              <input
                className="did-floating-input"
                type="text"
                placeholder=""
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
              <label className="did-floating-label">
                {t(inputLabel)} {t('NAME')}
                <span className="required">*</span>
              </label>
            </div>

            {/* Show additional Region input field when editing District */}
            {selectedKey === 'MASTER_DATA_DISTRICT' && (
              <>
                {/*  <div className="did-floating-label-content mt-3">
                <input
                  className="did-floating-input"
                  type="text"
                  placeholder=""
                  value={regionValue}
                  onChange={(e) => setRegionValue(e.target.value)}
                />
                <label className="did-floating-label">{t('REGIONNAME')}</label>
              </div> */}

                {/* Region Dropdown */}
                <div className="did-floating-label-content mt-3">
                  <select
                    className="did-floating-input"
                    value={regionValue}
                    onChange={(e) => setRegionValue(e.target.value)}
                  >
                    <option value="">{t('SELECTREGION')}</option>
                    {areas?.map((area) => (
                      <option key={area.id} value={area.id}>
                        {area.name}
                      </option>
                    ))}
                  </select>
                  <label className="did-floating-label">
                    {t('REGIONNAME')}
                  </label>
                </div>
              </>
            )}
            {(selectedKey === 'MASTER_DATA_ORIGIN' ||
              selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY') && (
              <div className="did-floating-label-content mt-3">
                <input
                  className="did-floating-input"
                  type="number"
                  placeholder=""
                  value={codeValue}
                  onChange={(e) => setCodeValue(e.target.value)}
                />
                <label className="did-floating-label">{t('CODE')}</label>
              </div>
            )}
            {selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY' && (
              <>
                {/* Process Category Dropdown */}
                <div className="did-floating-label-content mt-3">
                  <select
                    className="did-floating-input"
                    value={processCategoryId}
                    onChange={(e) => setProcessCategoryId(e.target.value)}
                  >
                    <option value="">{t('SELECTPROCESSCATEGORY')}</option>
                    {processCategories?.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                  <label className="did-floating-label">
                    {t('PROCESSCATEGORY')}
                  </label>
                </div>

                {/* Process Location Dropdown */}
                <div className="did-floating-label-content mt-3">
                  <select
                    className="did-floating-input"
                    value={processLocationId}
                    onChange={(e) => setProcessLocationId(e.target.value)}
                  >
                    <option value="">{t('SELECTPROCESSLOCATION')}</option>
                    {processLocations?.map((location) => (
                      <option key={location.id} value={location.id}>
                        {location.name}
                      </option>
                    ))}
                  </select>
                  <label className="did-floating-label">
                    {t('PROCESSLOCATION')}
                  </label>
                </div>
              </>
            )}

            <div className="bottom-button mt-3">
              <button
                onClick={handleSave}
                className={`save ${isDisable ? 'disable-btn' : ''}`}
                disabled={isDisable}
              >
                {t('SAVE')}
              </button>
              <button className="cancel" onClick={() => onClose('edit')}>
                {t('CANCEL')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
